import type {CSSProperties} from 'react';
import {WEDGE_BRIEF_READ as B} from '@territory/tokens';
import {wedgeExactRole as r} from './wedgeRoles.js';

export type WedgeBriefReadLook = 'briefread-clear' | 'briefread-row' | 'briefread-row-sep' | 'briefread-ask';

export const isWedgeBriefReadLook = (look: string | undefined): look is WedgeBriefReadLook => look !== undefined && look.startsWith('briefread-');

/* Released find bar of a brief (the reading chrome). Clear find is a 28px bare box hung 2px from the right edge of the field and centred
   on it. A result row of the drop-down list is a full width flex line, 44px tall at least, bare, in the page font; every row after the
   first (`briefread-row-sep`) carries a hairline separator edge on top. Ask Blip about this is an amber pill on the fixed amber wash
   with the gold ink, 8px below the zero hit message. Each keeps the declaration order of the source so the shipped ink rules keep
   matching the serialized text. None draws a transparent target or an anchor (`wedgeSettingsDrawsHit`, and a `content: none` rule
   naming the prefix): the field is the target, rows touch each other and the pill sits inside a panel. */
export function wedgeBriefReadStyle(look: WedgeBriefReadLook): CSSProperties {
  switch (look) {
    case 'briefread-clear': return {
      position: 'absolute', right: 2, top: '50%', transform: 'translateY(-50%)', width: 28, height: 28, background: 'transparent', border: 0,
      cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
    };
    case 'briefread-row': case 'briefread-row-sep': return {
      width: '100%', display: 'flex', alignItems: 'center', gap: 10, textAlign: 'left', padding: '10px 12px', minHeight: 44, cursor: 'pointer',
      background: 'transparent', border: 0, borderTop: look === 'briefread-row' ? 'none' : `0.5px solid ${r('separator')}`,
      fontFamily: r('font'), touchAction: 'manipulation', WebkitTapHighlightColor: 'transparent',
    };
    case 'briefread-ask': return {
      marginTop: 8, display: 'inline-flex', alignItems: 'center', gap: 6, background: B.askFill, color: r('gold'), border: 0, borderRadius: 999,
      padding: '7px 12px', fontSize: 12.5, fontWeight: 700, fontFamily: r('font'), cursor: 'pointer', touchAction: 'manipulation',
      WebkitTapHighlightColor: 'transparent',
    };
  }
}
